import { createIcon } from './icon-utils';

export const StartFromTemplateIcon = createIcon({
  fill: '#146EE8',
  path: 'M3 3H11V11H3V3ZM13 3H21V11H13V3ZM3 13H11V21H3V13ZM16 13H18V16H21V18H18V21H16V18H13V16H16V13ZM15 5V9H19V5H15ZM5 5V9H9V5H5ZM5 15V19H9V15H5Z',
  style: { height: 32, width: 32 },
});
